<template>
  <div class="container">
    <div class="row">
      <fieldset :disabled="!isEditable">
        <div class="col-md-12 mb-20">
          <h3 class="center">{{ $t('organization.pickOrganization') }}</h3>
        </div>
        <div class="col-md-5 text-right mt-10">
          <form-error v-if="userOrganization"  :errors='errors' :attribute="'my_organization'">
            <h4 class="mt-0">{{ userOrganization.name }}</h4>
            <checkbox v-if="userOrganization.status === 'approved'"
              :checked="project.organization_id === userOrganization.id"
              @change="pickUserOrganization()">
              <span slot="label">{{ $t('project.form.createForMyOrganization') }}</span>
            </checkbox>
            <div v-else>{{ $t('project.form.organizationNotConfirmed') }}</div>
          </form-error>
          <div v-else>
            <h4 class="user-link--yellow mt-15">
              <router-link to="/profile/edit#organization">{{ $t('project.form.createOrganization') }}</router-link>
            </h4>
          </div>
        </div>
        <div class="col-md-2">
          <h3 class="center">{{ $t('or') }}</h3>
        </div>
        <div class="col-md-4 mt-10">
          <p>{{ $t('project.form.pickOrganization') }}</p>
          <form-error :errors='errors' :attribute="'organization'">
            <multiselect v-model="organization"
              class="rais"
              :options="organizations"
              track-by="id"
              label="name"
              @select="selectOrganization"
              @remove="project.organization_id = null"
              :placeholder="$t('organization.organization')"
              :showLabels="false">
              <span slot="noResult">{{ $t('noResults') }}</span>
            </multiselect>
          </form-error>
        </div>
      </fieldset>
    </div>
  </div>
</template>

<script>
import organizationsApi from '@/api/v1/organizations';
import userOrganizationApi from '@/api/v1/user';
import FormError from '@/components/FormError';
import Multiselect from 'vue-multiselect';
import Checkbox from '@/components/Utils/Inputs/Checkbox';

export default {
  props: ['project', 'errors'],
  components: { FormError, Multiselect, Checkbox },
  data() {
    return {
      organizations: [],
      userOrganization: {},
      organization: {},
    };
  },
  computed: {
    isEditable() {
      return !this.project.status || this.project.status === 'created';
    },
  },
  methods: {
    selectOrganization(option) {
      this.project.organization_id = option.id;
    },
    pickUserOrganization() {
      this.project.organization_id = this.userOrganization.id;
    },
  },
  created() {
    userOrganizationApi.getOrganization((organization) => { this.userOrganization = organization; });
    organizationsApi.getOrganizations((organizations) => {
      this.organizations = organizations;
      this.organization = this.organizations.find(o => o.id === this.project.organization_id);
    });
  },
};
</script>
<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>



// WEBPACK FOOTER //
// ChooseOrganization.vue?5fdf1159